import { GenericStateMeta } from "store/common";
import { TrackingProperties } from "store/config";

export interface FetchAccountInfoReqDTO {
  clientId: number;
  accountQueryParameter: AccountQueryParameter[];
}

export interface FetchNonValidatedDTO {
  clientId: number;
  referenceNumber: string;
  accountType: string;
  captchaToken?: string; // opaque token from Google
  captchaVersion?: "v3" | "v2"; // tells backend which secret key to validate against
  challengeId?: string; // ties v3 and v2 challenges together in validation log
}

export interface AttachAccountReqDTO {
  accountQueryParameter: AccountQueryParameter[];
}

export interface AccountQueryParameter {
  trackingProperty: TrackingProperties;
  value: any;
}

export interface AccountInfoResponse {}

interface AccountExtends {
  [key: string]: any;
}

export interface AccountInfo extends AccountExtends {
  accountNumber: string;
  accountType: string;
  amountDue: number;
  otherAmountDue?: number;
  dueDate: string;
  balance: number;
  id: number;
  active: boolean;
  userId?: number;
  minimumAmountDue?: number;
  clientId: number;
  clientAttributes: number;
}

export interface AccountState {
  meta: GenericStateMeta;
  currentSelectedAccount?: number;
}

export enum AccountMatrix {
  None = 0,
  ReadOnly = 1 << 0, // 1
  EnableACH = 1 << 1, // 2
  EnableCard = 1 << 2, // 4
  EnableEWallet = 1 << 3, // 8
}

export interface AccountRestrictions {
  isInactive: boolean;
  isReadOnly: boolean;
  achRestricted: boolean;
  cardRestricted: boolean;
  eWalletRestricted: boolean;
}

export const defaultAccountRestrictions: AccountRestrictions = {
  isInactive: false,
  isReadOnly: false,
  achRestricted: false,
  cardRestricted: false,
  eWalletRestricted: false,
};
